import SeparatorLabel from "./separator-label.svelte"

export {
  SeparatorLabel,
}
